export const FILM_PARAM = "film";
export const SHOT_PARAM = "shot";
export const T0_PARAM = "t0";
export const FILM_STORE = "dh_sales_film";
export const TRANSITION_MS = 240;

export function filmOrigins() {
  if (typeof window === "undefined") {
    return {
      checklist: "https://rechecklist.pro",
      journey: "https://dreamhomejourney.online",
    };
  }
  const local = /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
  return {
    checklist: local ? "http://127.0.0.1:5173" : "https://rechecklist.pro",
    journey: local ? "http://127.0.0.1:5174" : "https://dreamhomejourney.online",
  };
}

export function thisFilmSite() {
  if (typeof window === "undefined") return "checklist";
  const { port, hostname } = window.location;
  if (port === "5174" || /dreamhomejourney/i.test(hostname)) return "journey";
  return "checklist";
}

export function parseFilmSearch(search) {
  const params = new URLSearchParams(search.startsWith("?") ? search : `?${search}`);
  const on = params.get(FILM_PARAM) === "1";
  const shot = Number(params.get(SHOT_PARAM) || "0");
  const record = params.get("record") === "1";
  const t0 = Number(params.get(T0_PARAM));
  return {
    on,
    shot: Number.isFinite(shot) ? Math.max(0, shot) : 0,
    record,
    t0: Number.isFinite(t0) && t0 > 0 ? t0 : null,
    fade: params.get("fade") === "1",
  };
}

function filmParams(index, record = false, t0) {
  const params = new URLSearchParams({ [FILM_PARAM]: "1", [SHOT_PARAM]: String(index) });
  if (record) params.set("record", "1");
  const clock = t0 || readFilmStore()?.t0;
  if (clock) params.set(T0_PARAM, String(Math.round(Number(clock))));
  return params;
}

export function filmHref(shot, index, record = false, t0) {
  const origins = filmOrigins();
  const origin = origins[shot.site];
  return `${origin}${shot.path}?${filmParams(index, record, t0)}`;
}

export function sameOriginHref(shot, index, record = false, t0) {
  return `${shot.path}?${filmParams(index, record, t0)}`;
}

export function withFilmQuery(path, search) {
  const film = parseFilmSearch(search || "");
  if (!film.on) return path;
  const qIndex = path.indexOf("?");
  const base = qIndex === -1 ? path : path.slice(0, qIndex);
  const extra = qIndex === -1 ? "" : path.slice(qIndex + 1);
  const params = new URLSearchParams(extra);
  const src = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  [FILM_PARAM, SHOT_PARAM, T0_PARAM, "record"].forEach((key) => {
    const value = src.get(key);
    if (value != null && value !== "") params.set(key, value);
  });
  const next = params.toString();
  return next ? `${base}?${next}` : base;
}

export function stripFilmSearch(search) {
  const params = new URLSearchParams(search.startsWith("?") ? search : `?${search}`);
  params.delete(FILM_PARAM);
  params.delete(SHOT_PARAM);
  params.delete(T0_PARAM);
  params.delete("record");
  params.delete("fade");
  const next = params.toString();
  return next ? `?${next}` : "";
}

export function readFilmStore() {
  try {
    return JSON.parse(sessionStorage.getItem(FILM_STORE) || "null");
  } catch {
    return null;
  }
}

export function writeFilmStore(patch) {
  try {
    const next = { ...(readFilmStore() || {}), ...patch };
    sessionStorage.setItem(FILM_STORE, JSON.stringify(next));
    return next;
  } catch {
    return { ...(readFilmStore() || {}), ...patch };
  }
}

export function clearFilmStore() {
  try {
    sessionStorage.removeItem(FILM_STORE);
  } catch {
    /* ignore */
  }
}

export function tourNavId(label) {
  const slug = String(label || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
  return slug ? `nav-${slug}` : undefined;
}
